import React, { useState } from "react";
import { Box, Link, Typography, Modal, Sheet, Button } from "@mui/joy";
import { useTranslation, Trans } from "react-i18next";

const Footer = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 3,
        borderTop: "1px solid #e3e3e3",
        textAlign: "center",
        fontSize: "0.97rem",
        color: "#333",
        background: "rgba(255,255,255,0.83)",
        position: "relative"
      }}
    >
      <Link
        component="button"
        underline="hover"
        sx={{ mx: 1, cursor: "pointer" }}
        onClick={() => setOpen(true)}
      >
        {t("footer.privacyPolicy")}
      </Link>
      <Link
        href="mailto:kontakt@revealoo.com"
        underline="hover"
        sx={{ mx: 1 }}
      >
        {t("footer.contact")}
      </Link>
      <Typography sx={{ mt: 1, fontSize: "0.87rem", color: "#888" }}>
        © 2025 revealoo.com
      </Typography>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >
        <Typography sx={{ fontSize: "0.98rem", color: "#9ca3af" }}>
          {t("footer.poweredBy")}
        </Typography>
        <Link
          href="https://kalmarry.pl"
          target="_blank"
          rel="noopener"
          sx={{
            color: "#ec407a",
            fontWeight: 700,
            fontSize: "1rem",
            letterSpacing: "0.02em",
            textDecoration: "none",
            transition: "color 0.2s, text-shadow 0.2s",
            textShadow: "0 1px 8px #ffe4f7, 0 0px #d0eaff",
            "&:hover": {
              color: "#2d3c88",
              textShadow: "0 2px 20px #fce4ec, 0 2px #90caf9",
            }
          }}
        >
          Kalmarry.pl
        </Link>
      </Box>

      {/* Polityka prywatności - Modal */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            minWidth: 340,
            maxWidth: 420,
            borderRadius: "md",
            boxShadow: "lg",
            p: 3,
            background: "#fff"
          }}
        >
          <Typography id="modal-title" level="h3" sx={{ color: "#2d3c88", mb: 2, fontWeight: 700 }}>
            {t("footer.privacyTitle")}
          </Typography>
          <Typography sx={{ mb: 1 }}>
            <Trans i18nKey="footer.privacy1" components={{ b: <b /> }} />
          </Typography>
          <Typography sx={{ mb: 1 }}>
            <Trans i18nKey="footer.privacy2" />
          </Typography>
          <Typography sx={{ mb: 1 }}>
            <Trans i18nKey="footer.privacy3" />
          </Typography>
          <Typography sx={{ mb: 1 }}>
            <Trans i18nKey="footer.privacy4" />
          </Typography>
          <Typography sx={{ mb: 1 }}>
            <Trans
              i18nKey="footer.privacy5"
              components={{
                email: (
                  <a href="mailto:kontakt@revealoo.com" style={{ color: "#ec407a" }} />
                )
              }}
            />
          </Typography>
          <Typography sx={{ fontSize: "0.97rem", color: "#9ca3af", mt: 2 }}>
            {t("footer.lastUpdate")}
          </Typography>
          <Button onClick={() => setOpen(false)} variant="soft" color="primary" sx={{ mt: 3 }}>
            Zamknij
          </Button>
        </Sheet>
      </Modal>
    </Box>
  );
};

export default Footer;
